export enum FIELDS {
    FLAGS = "FLAGS",
    ASSIGNED = "ASSIGNED",
    DUESEVENDAYS = "DUESEVENDAYS",
    OVERDUEDAYS = "OVERDUEDAYS",
    TODAYDUEDAYS = "TODAYDUEDAYS",
    DATE = "DATE",
    TASK = "TASK",
    PROJECTS = "PROJECTS",
    SEARCH ="SEARCH",
STATUS ="STATUS",
DELAY ="DELAY",
BUDGET = "BUDGET"
  }
export enum RISKFIELDS {
    TYPE = "TYPE",
    IMPACT = "IMPACT",
    SEVERITY = "SEVERITY",
    STATUS = "STATUS",
    RESPONSIBLE = "RESPONSIBLE",
    TREND = "TREND",
    PROBABILITY = "PROBABILITY",
    TITLE = "TITLE",
  }
  
  